import { ShellConfig } from '@gc-bridge/models';
import { isEqual } from 'lodash';
import { useConfigStore } from '../stores/config';

class ConfigService {
  async loadConfig() {
    const previousConfig = useConfigStore.getState().config;

    try {
      if (process.env.NX_PUBLIC_LOCAL_STORAGE_REMOTES === 'true') {
        console.log('Loading configuration from local storage.');
        const localConfig = localStorage.getItem('shell-config');

        if (localConfig) {
          const parsedConfig = JSON.parse(localConfig);
          if (parsedConfig) {
            // TODO: We should probably validate the format here before setting it
            return this.applyConfig(parsedConfig, previousConfig);
          }
        }

        console.warn(
          'No "shell-config" found in localStorage. Falling back to config file.'
        );
      }

      const response = await fetch('../public/config.json');
      if (!response.ok) {
        throw new Error('Response was not ok');
      }

      const parsedConfig = JSON.parse(await response.text());
      if (parsedConfig) {
        return this.applyConfig(parsedConfig, previousConfig);
      }
    } catch (error) {
      if (previousConfig) {
        console.warn(
          'An error occurred while reloading config, using last known good config.',
          error
        );
        return { config: previousConfig, hasChanged: false };
      }
      throw error;
    }

    return { config: previousConfig, hasChanged: false };
  }

  private applyConfig(newConfig: ShellConfig, previousConfig: ShellConfig | undefined) {
    if (isEqual(newConfig, previousConfig)) {
      return { config: previousConfig, hasChanged: false };
    }

    useConfigStore.getState().setConfig(newConfig);
    return { config: newConfig, hasChanged: true };
  }
}
export const configService = new ConfigService();
